import React, { useEffect, useState, } from "react";
import { useHistory } from "react-router-dom";
import AdminS from "layouts/AdminS";
import Footer from "components/Footer/Footer";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";
import { createPrinter } from "typescript";

import firebase from "../firebase";

const userLocations=()=> {

  let history = useHistory();
  
//Stroring Reteriwing Data
const[userData,setUserData]= useState([]);

useEffect(()=>{

  const files = firebase.database().ref("LocationSharingLog");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    setUserData(dataList);
    console.log(dataList);
  }) 
    
},[]);

const filterData=(datas,searchKey)=>{

  const result = datas.filter(
    (data)=>
    data.UserName.toUpperCase().includes(searchKey) ||
    data.UserName.toLowerCase().includes(searchKey)
    //data..toLowerCase().includes(searchKey)
     //Searching via 
  );
  setUserData(result);
}

// const Changestatus = (id,status) =>{
//   const files = firebase.database().ref("user_information").child(id);
  
//   let data = {
//     status:status, 
//   };
//   files.update(data);
//   if(status == 1){
//     alert("Activated");
//   }
//   else if(status == 0){
//     alert("Deactivated");
//   } 
// }

const handleInput=(e)=>{
  const searchKey = e.currentTarget.value;

  const files = firebase.database().ref("LocationSharingLog");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    filterData(dataList, searchKey);
  })    
}
  return (
    <>
    <AdminS/>

<br/>


<Container>

  <Row>
    <Col md={{ span: 12, offset: 1 }}>  
    <Container fluid>
<FormControl
    type="search"
    placeholder="Search by UserName" 
    className="mr-2"
    aria-label="Search"
    name="searchQuery"
    onChange={handleInput}
  />
 <br/>
        <Table className = "text-center" striped bordered hover>
        <thead>
            <tr>
            <th>Index</th>
            <th>User Name</th>
            <th>Duration</th>
            <th>Latitude</th>
            <th>Longitude</th>
            <th><center>Action</center></th>
            </tr>
        </thead>
        <tbody>{userData.map((data, index)=>(
            <tr>
            <td>{index + 1}</td>
            <td>{data.UserName}</td>
            <td>{data.Duration}</td>
            <td>{data.Latitude}</td>
            <td>{data.Longitude}</td>
            {/* Metana Change karaddi Aniva ballane in Intergration Coloumn shouldbe changed */}
            <center>
            <Button href={`/ActivateRewards/${data.UserName}`} className = "mx-2" variant="primary" size="" active>
              Activate
            </Button>{' '}
            {/* <Button className = "ml-2 mr-0" variant="primary" size="" active>
              Deactivate 
            </Button> */}
            </center>
            </tr>
            ))}
        </tbody>
        </Table>
        </Container>
        </Col>
  </Row>

  
</Container>


<Footer /> 
        </>
        ) ;
    }
export default userLocations;